exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#alinear[data-v-d472c8a4] {\n  text-align: justify;\n}\n.h2_title[data-v-d472c8a4] {\n  font-weight: normal;\n}\n", ""]);

// exports
